export default function({ commit }, query) {
    commit('handoffToken', query)
    return Promise.resolve()
}
